<template>
    <div class="menu-editor">
      <div class="form-group">
        <h1>Antipasto</h1>
        <label>Titolo Antipasto</label>
        <input type="text" v-model="antipasto.title">
      </div>
      <div class="form-group">
        <label>Descrizione Antipasto</label>
        <textarea v-model="antipasto.description"></textarea>
      </div>
      <div class="form-group">
        <label>Mostra Antipasto</label>
        <input type="checkbox" v-model="antipasto.show">
      </div>
      <hr/>
      <h1>Primo Piatto</h1>
      <div class="form-group">
        <label>Titolo Primo Piatto</label>
        <input type="text" v-model="primoPiatto.title">
      </div>
      <div class="form-group">
        <label>Descrizione Primo Piatto</label>
        <textarea v-model="primoPiatto.description"></textarea>
      </div>
      <div class="form-group">
        <label>Mostra Primo Piatto</label>
        <input type="checkbox" v-model="primoPiatto.show">
      </div>
      <hr/>
      <h1>Secondo Piatto</h1>
      <div class="form-group">
        <label>Titolo Secondo Piatto</label>
        <input type="text" v-model="secondoPiatto.title">
      </div>
      <div class="form-group">
        <label>Descrizione Secondo Piatto</label>
        <textarea v-model="secondoPiatto.description"></textarea>
      </div>
      <div class="form-group">
        <label>Mostra Secondo Piatto</label>
        <input type="checkbox" v-model="secondoPiatto.show">
      </div>
      <hr/>
      <h1>Frutta/Dolce</h1>
      <div class="form-group">
        <label>Titolo Frutta/Dolce</label>
        <input type="text" v-model="frutta.title">
      </div>
      <div class="form-group">
        <label>Descrizione Frutta/Dolce</label>
        <textarea v-model="frutta.description"></textarea>
      </div>
      <div class="form-group">
        <label>Mostra Frutta/Dolce</label>
        <input type="checkbox" v-model="frutta.show">
      </div>
      <hr/>
      <h1>Bevande</h1>
      <div class="form-group">
        <label>Titolo Bevande</label>
        <input type="text" v-model="bevande.title">
      </div>
      <div class="form-group">
        <label>Descrizione Bevande</label>
        <textarea v-model="bevande.description"></textarea>
      </div>
      <div class="form-group">
        <label>Mostra Bevande</label>
        <input type="checkbox" v-model="bevande.show">
      </div>
      <hr/>
      <div class="form-group">
        <label>Prezzo Menu</label>
        <input type="number" v-model="menuPrice">
      </div>
      <div class="form-group">
        <label>Disponibile</label>
        <input type="checkbox" v-model="thereIs" class="special-checkbox-input">
      </div>
  
      <button @click="saveChanges">Applica Modifiche</button>
    </div>
  </template>
  <script>

  import { fetchDailyMenu, updateDailyMenu } from '@/api/DailyMenuAPI'; 

  export default {
    data() {
      return {
        antipasto: { title: "", description: "", show: true },
        primoPiatto: { title: "", description: "", show: true },
        secondoPiatto: { title: "", description: "", show: true },
        frutta: { title: "", description: "", show: true },
        bevande: { title: "", description: "", show: true },
        menuPrice: 0,
        animatedPrice: 0,
        thereIs: false
      };
    },
    async created() {
        this.animatedPrice = this.menuPrice
  try {
    const dailyMenuData = await fetchDailyMenu(); 
    if (dailyMenuData.length > 0) {
      const dailyMenu = dailyMenuData[0]; 
      this.antipasto = {
        title: dailyMenu.antipasto_title,
        description: dailyMenu.antipasto_description,
        show: dailyMenu.antipasto_show
      };
      this.primoPiatto = {
        title: dailyMenu.primo_piatto_title,
        description: dailyMenu.primo_piatto_description,
        show: dailyMenu.primo_piatto_show
      };
      this.secondoPiatto = {
        title: dailyMenu.secondo_piatto_title,
        description: dailyMenu.secondo_piatto_description,
        show: dailyMenu.secondo_piatto_show
      };
      this.frutta = {
        title: dailyMenu.frutta_title,
        description: dailyMenu.frutta_description,
        show: dailyMenu.frutta_show
      };
      this.bevande = {
        title: dailyMenu.bevande_title,
        description: dailyMenu.bevande_description,
        show: dailyMenu.bevande_show
      };
      if (!isNaN(dailyMenu.menu_price)) {
        this.menuPrice = parseFloat(dailyMenu.menu_price);
      } else {
        this.menuPrice = 0; 
      }
      if (!isNaN(dailyMenu.animated_price)) {
        this.animatedPrice = parseFloat(dailyMenu.animated_price);
      } else {
        this.animatedPrice = 0; 
      }
      this.thereIs = dailyMenu.there_is;
    }
  } catch (error) {
    console.error("Error loading daily menu:", error);
  }
},
    methods: {
        async saveChanges() {
  try {
    const updatedMenuData = {
      antipasto_title: this.antipasto.title,
      antipasto_description: this.antipasto.description,
      antipasto_show: this.antipasto.show,
      primo_piatto_title: this.primoPiatto.title,
      primo_piatto_description: this.primoPiatto.description,
      primo_piatto_show: this.primoPiatto.show,
      secondo_piatto_title: this.secondoPiatto.title,
      secondo_piatto_description: this.secondoPiatto.description,
      secondo_piatto_show: this.secondoPiatto.show,
      frutta_title: this.frutta.title,
      frutta_description: this.frutta.description,
      frutta_show: this.frutta.show,
      bevande_title: this.bevande.title,
      bevande_description: this.bevande.description,
      bevande_show: this.bevande.show,
      menu_price: this.menuPrice,
      animated_price: this.animatedPrice,
      there_is: this.thereIs
    };
    this.$emit('updated-daily-menu')
    await updateDailyMenu(updatedMenuData);
    console.log("Changes saved!");
  } catch (error) {
    console.error("Error saving changes:", error);
  }
}

    }
  };  
  
  </script>
  <style scoped>
  hr{
    border-top: 5px solid var(--accent-color); 
  }
  .menu-editor {
    max-width: 600px;
    margin: 20px;
    margin-bottom: 0px;
    padding: 20px;
    background-color: var(--primary-color);
    color: var(--text-color);
    border: 1px solid var(--border-color);
    border-radius: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    font-weight: bold;
    margin: 4px;
  }
  
  input[type="text"],
  input[type="number"],
  textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    background-color: var(--secondary-color);
    color: var(--text-color);
  }
  
  button {
    padding: 10px 20px;
    background-color: var(--accent-color);
    color: var(--text-color);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: block;
    margin: auto;
    
  }
  
  button:hover {
    background-color: var(--accent-color-clicked);
  }
.special-checkbox-input{
  transform: scale(1.6); 
  margin-left: 5px
}
  </style>
  